import script from "./MessageChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageChip.vue?vue&type=script&setup=true&lang=ts"

import "./MessageChip.vue?vue&type=style&index=0&id=1694a056&lang=css"

const __exports__ = script;

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
